/**
 * Base de données complète des codes postaux suisses (NPA)
 * Couvre tous les cantons de Suisse
 */

const NPA_LOCALITES = {
  // ============================================
  // CANTON DE NEUCHÂTEL (NE)
  // ============================================
  "2000": "Neuchâtel", "2001": "Neuchâtel 1", "2002": "Neuchâtel 2", "2003": "Neuchâtel 3",
  "2004": "Neuchâtel 4", "2006": "Neuchâtel 6", "2007": "Neuchâtel 7",
  "2008": "Neuchâtel 8", "2009": "Neuchâtel 9", "2010": "Neuchâtel",
  "2012": "Auvernier", "2013": "Colombier NE", "2014": "Bôle", "2015": "Areuse",
  "2016": "Cortaillod", "2017": "Boudry", "2019": "Chambrelien",
  "2022": "Bevaix", "2023": "Gorgier", "2024": "St-Aubin-Sauges",
  "2025": "Chez-le-Bart", "2027": "Montalchez", "2028": "Vaumarcus",
  "2034": "Peseux", "2035": "Corcelles NE", "2036": "Cormondrèche",
  "2037": "Montmollin", "2042": "Valangin", "2043": "Boudevilliers",
  "2046": "Fontaines NE", "2052": "Fontainemelon", "2053": "Cernier",
  "2054": "Chézard-St-Martin", "2056": "Dombresson", "2057": "Villiers",
  "2058": "Le Pâquier NE", "2063": "Vilars NE", "2065": "Savagnier",
  "2067": "Chaumont", "2068": "Hauterive NE", "2072": "St-Blaise",
  "2073": "Enges", "2074": "Marin-Epagnier", "2075": "Thielle",
  "2087": "Cornaux NE", "2088": "Cressier NE",
  "2105": "Travers", "2108": "Couvet", "2112": "Môtiers NE",
  "2113": "Boveresse", "2114": "Fleurier", "2115": "Buttes",
  "2116": "Mont-de-Buttes", "2117": "La Côte-aux-Fées",
  "2123": "St-Sulpice NE", "2124": "Les Sagnettes", "2126": "Les Verrières",
  "2127": "Les Bayards", "2149": "Champ-du-Moulin",
  "2300": "La Chaux-de-Fonds", "2301": "La Chaux-de-Fonds 1",
  "2302": "La Chaux-de-Fonds 2", "2303": "La Chaux-de-Fonds 3",
  "2304": "La Chaux-de-Fonds 4", "2314": "La Sagne NE",
  "2316": "Les Ponts-de-Martel", "2318": "Brot-Plamboz",
  "2322": "Le Crêt-du-Locle", "2325": "Les Planchettes",
  "2400": "Le Locle", "2405": "La Chaux-du-Milieu",
  "2406": "Le Brévine", "2414": "Le Cerneux-Péquignot", "2416": "Les Brenets",

  // ============================================
  // CANTON DE GENÈVE (GE)
  // ============================================
  "1200": "Genève", "1201": "Genève", "1202": "Genève", "1203": "Genève",
  "1204": "Genève", "1205": "Genève", "1206": "Genève", "1207": "Genève",
  "1208": "Genève", "1209": "Genève", "1210": "Genève", "1211": "Genève",
  "1212": "Grand-Lancy", "1213": "Onex", "1214": "Vernier", "1215": "Genève",
  "1216": "Cointrin", "1217": "Meyrin", "1218": "Le Grand-Saconnex",
  "1219": "Aïre", "1220": "Les Avanchets", "1222": "Vésenaz",
  "1223": "Cologny", "1224": "Chêne-Bougeries", "1225": "Chêne-Bourg",
  "1226": "Thônex", "1227": "Carouge GE", "1228": "Plan-les-Ouates",
  "1229": "Genève", "1231": "Conches", "1232": "Confignon",
  "1233": "Bernex", "1234": "Vessy", "1236": "Cartigny",
  "1237": "Avully", "1239": "Collex-Bossy", "1241": "Puplinge",
  "1242": "Satigny", "1243": "Presinge", "1244": "Choulex",
  "1245": "Collonge-Bellerive", "1246": "Corsier GE", "1247": "Anières",
  "1248": "Hermance", "1251": "Gy", "1252": "Meinier",
  "1253": "Vandoeuvres", "1254": "Jussy", "1255": "Veyrier",
  "1256": "Troinex", "1257": "La Croix-de-Rozon", "1258": "Perly",

  // ============================================
  // CANTON DE VAUD (VD) - COMPLET
  // ============================================
  // Lausanne et agglomération
  "1000": "Lausanne", "1001": "Lausanne", "1002": "Lausanne", "1003": "Lausanne",
  "1004": "Lausanne", "1005": "Lausanne", "1006": "Lausanne", "1007": "Lausanne",
  "1008": "Prilly", "1009": "Pully", "1010": "Lausanne", "1011": "Lausanne",
  "1012": "Lausanne", "1014": "Lausanne", "1015": "Lausanne", "1018": "Lausanne",
  "1020": "Renens VD", "1022": "Chavannes-près-Renens", "1023": "Crissier",
  "1024": "Ecublens VD", "1025": "St-Sulpice VD", "1026": "Denges",
  "1027": "Lonay", "1028": "Préverenges", "1029": "Villars-Ste-Croix",
  "1030": "Bussigny", "1031": "Mex VD", "1032": "Romanel-sur-Lausanne",
  "1033": "Cheseaux-sur-Lausanne", "1034": "Boussens", "1035": "Bournens",
  "1036": "Sullens", "1037": "Etagnières", "1038": "Bercher",
  "1040": "Echallens", "1041": "Bottens", "1042": "Assens",
  "1043": "Sugnens", "1044": "Fey", "1045": "Ogens",
  "1046": "Rueyres", "1047": "Oppens", "1052": "Le Mont-sur-Lausanne",
  "1053": "Cugy VD", "1054": "Morrens VD", "1055": "Froideville",
  "1058": "Villars-Tiercelin", "1059": "Peney-le-Jorat",
  
  // Lavaux et Riviera
  "1063": "Chapelle-sur-Moudon", "1066": "Epalinges",
  "1068": "Les Monts-de-Pully", "1070": "Puidoux", "1071": "Chexbres",
  "1072": "Forel (Lavaux)", "1073": "Savigny", "1076": "Ferlens VD",
  "1077": "Servion", "1078": "Essertes", "1080": "Les Cullayes",
  "1081": "Montpreveyres", "1083": "Mézières VD", "1084": "Carrouge VD",
  "1085": "Vulliens", "1088": "Ropraz", "1090": "La Croix (Lutry)",
  "1091": "Grandvaux", "1092": "Belmont-sur-Lausanne", "1093": "La Conversion",
  "1094": "Paudex", "1095": "Lutry", "1096": "Cully", "1097": "Riex",
  "1098": "Epesses",
  
  // Montreux, Vevey et Riviera
  "1800": "Vevey", "1801": "Le Mont-Pèlerin", "1802": "Corseaux",
  "1803": "Chardonne", "1804": "Corsier-sur-Vevey", "1805": "Jongny",
  "1806": "St-Légier-La Chiésaz", "1807": "Blonay", "1808": "Les Monts-de-Corsier",
  "1809": "Fenil-sur-Corsier", "1814": "La Tour-de-Peilz",
  "1815": "Clarens", "1816": "Chailly-Montreux", "1817": "Brent",
  "1818": "Montreux", "1820": "Montreux", "1822": "Chernex",
  "1823": "Glion", "1824": "Caux", "1832": "Chamby", "1833": "Les Avants",
  "1844": "Villeneuve VD", "1845": "Noville", "1846": "Chessel",
  "1847": "Rennaz", "1852": "Roche VD", "1853": "Yvorne",
  "1854": "Leysin", "1856": "Corbeyrier", "1860": "Aigle",
  "1862": "La Comballaz", "1863": "Le Sépey", "1864": "Vers-l'Eglise",
  "1865": "Les Diablerets", "1866": "La Forclaz VD", "1867": "Ollon VD",
  "1868": "Collombey", "1880": "Bex", "1882": "Gryon",
  "1884": "Villars-sur-Ollon", "1885": "Chesières", "1890": "St-Maurice",
  "1891": "Vérossaz", "1892": "Lavey-Village", "1893": "Muraz (Collombey)",
  "1895": "Vionnaz", "1896": "Vouvry", "1897": "Le Bouveret",
  "1898": "St-Gingolph",
  
  // Nyon et La Côte
  "1260": "Nyon", "1261": "Le Vaud", "1262": "Eysins", "1263": "Crassier",
  "1264": "St-Cergue", "1265": "La Cure", "1266": "Duillier",
  "1267": "Coinsins", "1268": "Begnins", "1269": "Bassins",
  "1270": "Trélex", "1271": "Givrins", "1272": "Genolier",
  "1273": "Arzier-Le Muids", "1274": "Grens", "1275": "Chéserex",
  "1276": "Gingins", "1277": "Borex", "1278": "La Rippe",
  "1279": "Chavannes-de-Bogis", "1280": "Chavannes-des-Bois",
  "1281": "Russin", "1283": "Dardagny", "1284": "Chancy",
  "1285": "Athenaz (Avusy)", "1286": "Soral", "1287": "Laconnex",
  "1288": "Aire-la-Ville", "1290": "Versoix", "1291": "Commugny",
  "1292": "Chambésy", "1293": "Bellevue", "1294": "Genthod",
  "1295": "Mies", "1296": "Coppet", "1297": "Founex", "1298": "Céligny",
  "1299": "Crans-près-Céligny",
  
  // Morges et environs
  "1110": "Morges", "1111": "Tolochenaz", "1112": "Echichens",
  "1113": "St-Saphorin-sur-Morges", "1114": "Colombier VD",
  "1115": "Vullierens", "1116": "Cottens VD", "1117": "Grancy",
  "1121": "Bremblens", "1122": "Romanel-sur-Morges", "1123": "Aclens",
  "1124": "Gollion", "1125": "Monnaz", "1126": "Vaux-sur-Morges",
  "1127": "Clarmont", "1128": "Reverolle", "1131": "Tolochenaz",
  "1132": "Lully VD", "1134": "Vufflens-le-Château", "1135": "Denens",
  "1136": "Bussy-Chardonney", "1141": "Sévery", "1142": "Pampigny",
  "1143": "Apples", "1144": "Ballens", "1145": "Bière", "1146": "Mollens VD",
  "1147": "Montricher", "1148": "L'Isle", "1149": "Berolle",
  "1162": "St-Prex", "1163": "Etoy", "1164": "Buchillon",
  "1165": "Allaman", "1166": "Perroy", "1167": "Lussy-sur-Morges",
  "1168": "Villars-sous-Yens", "1169": "Yens", "1170": "Aubonne",
  "1172": "Bougy-Villars", "1173": "Féchy", "1174": "Montherod",
  "1175": "Lavigny", "1176": "St-Livres", "1180": "Rolle",
  "1182": "Gilly", "1183": "Bursins", "1184": "Luins",
  "1185": "Mont-sur-Rolle", "1186": "Essertines-sur-Rolle",
  "1187": "St-Oyens", "1188": "Gimel", "1189": "Saubraz",
  
  // Yverdon et Nord vaudois
  "1400": "Yverdon-les-Bains", "1401": "Yverdon-les-Bains",
  "1404": "Cuarny", "1405": "Pomy", "1406": "Cronay",
  "1407": "Donneloye", "1408": "Prahins", "1409": "Chanéaz",
  "1410": "Thierrens", "1412": "Ursins", "1413": "Orzens",
  "1415": "Molondin", "1416": "Pailly", "1417": "Epautheyres",
  "1418": "Vuarrens", "1420": "Fiez", "1421": "Grandevent",
  "1422": "Grandson", "1423": "Villars-Burquin", "1424": "Champagne",
  "1425": "Onnens VD", "1426": "Concise", "1427": "Bonvillars",
  "1428": "Mutrux", "1429": "Giez", "1430": "Orges",
  "1431": "Vugelles-La Mothe", "1432": "Belmont-sur-Yverdon",
  "1433": "Suchy", "1434": "Ependes VD", "1435": "Essert-Pittet",
  "1436": "Chamblon", "1437": "Suscévaz", "1438": "Mathod",
  "1439": "Rances", "1440": "Montagny-près-Yverdon", "1441": "Valeyres-sous-Montagny",
  "1442": "Montagny-près-Yverdon", "1443": "Essert-sous-Champvent",
  "1445": "Vuiteboeuf", "1446": "Baulmes", "1450": "Ste-Croix",
  "1452": "Les Rasses", "1453": "Bullet", "1454": "L'Auberson",
  "1462": "Yvonand", "1463": "Rovray", "1464": "Chavannes-le-Chêne",
  "1468": "Cheyres", "1470": "Estavayer-le-Lac", "1473": "Font",
  "1474": "Châbles FR", "1475": "Autavaux", "1482": "Cugy FR",
  "1483": "Frasses", "1484": "Aumont", "1485": "Nuvilly",
  "1486": "Vuissens", "1489": "Murist",
  
  // Payerne et Broye
  "1530": "Payerne", "1532": "Fétigny", "1533": "Ménières",
  "1534": "Sassel", "1535": "Combremont-le-Grand", "1536": "Combremont-le-Petit",
  "1537": "Champtauroz", "1538": "Treytorrens (Payerne)", "1541": "Morens FR",
  "1542": "Rueyres-les-Prés", "1543": "Grandcour", "1544": "Gletterens",
  "1545": "Chevroux", "1551": "Vers-chez-Perrin", "1552": "Trey",
  "1553": "Châtonnaye", "1554": "Rossens VD", "1555": "Villarzel",
  "1562": "Corcelles-près-Payerne", "1565": "Missy", "1566": "St-Aubin FR",
  "1567": "Delley-Portalban", "1568": "Portalban",
  
  // Moudon et environs
  "1510": "Moudon", "1512": "Chavannes-sur-Moudon", "1513": "Rossenges",
  "1514": "Bussy-sur-Moudon", "1515": "Neyruz-sur-Moudon", "1521": "Curtilles",
  "1522": "Lucens", "1523": "Granges-près-Marnand", "1524": "Marnand",
  "1525": "Henniez", "1526": "Cremin", "1527": "Villeneuve FR",
  "1528": "Surpierre", "1529": "Cheiry",
  
  // Vallée de Joux
  "1342": "Le Pont", "1343": "Les Charbonnières", "1344": "L'Abbaye",
  "1345": "Le Lieu", "1346": "Les Bioux", "1347": "Le Sentier",
  "1348": "Le Brassus",
  
  // Orbe et environs
  "1350": "Orbe", "1352": "Agiez", "1353": "Bofflens", "1354": "Montcherand",
  "1355": "L'Abergement", "1356": "Les Clées", "1357": "Lignerolle",
  "1358": "Valeyres-sous-Rances", "1372": "Bavois", "1373": "Chavornay",
  "1374": "Corcelles-sur-Chavornay", "1375": "Penthéréaz",
  "1376": "Eclagnens", "1377": "Oulens-sous-Echallens",
  "1350": "Orbe", "1358": "Valeyres-sous-Rances",
  
  // Cossonay et environs
  "1304": "Cossonay-Ville", "1305": "Penthalaz", "1306": "Daillens",
  "1307": "Lussery-Villars", "1308": "La Chaux (Cossonay)",
  "1310": "Daillens", "1312": "Eclépens", "1313": "Ferreyres",
  "1315": "La Sarraz", "1316": "Chevilly", "1317": "Orny",
  "1318": "Pompaples", "1321": "Arnex-sur-Orbe", "1322": "Croy",
  "1323": "Romainmôtier", "1324": "Premier", "1325": "Vaulion",
  "1326": "Juriens", "1329": "Bretonnières",
  
  // ============================================
  // CANTON DE FRIBOURG (FR)
  // ============================================
  "1700": "Fribourg", "1701": "Fribourg", "1702": "Fribourg",
  "1704": "Fribourg", "1705": "Fribourg", "1708": "Fribourg", "1709": "Fribourg",
  "1712": "Tafers", "1713": "St. Antoni", "1714": "Heitenried",
  "1715": "Alterswil FR", "1716": "Plaffeien", "1717": "St. Ursen",
  "1718": "Rechthalten", "1719": "Brünisried", "1720": "Corminboeuf",
  "1721": "Misery-Courtion", "1722": "Bourguillon", "1723": "Marly",
  "1724": "Le Mouret", "1725": "Posieux", "1726": "Farvagny",
  "1727": "Corpataux-Magnedens", "1728": "Rossens FR", "1730": "Ecuvillens",
  "1731": "Ependes FR", "1732": "Arconciel", "1733": "Treyvaux",
  "1734": "Tentlingen", "1735": "Giffers", "1736": "St. Silvester",
  "1737": "Plasselb", "1738": "Sangernboden", "1740": "Neyruz FR",
  "1741": "Cottens FR", "1742": "Autigny", "1744": "Chénens",
  "1745": "Lentigny", "1746": "Prez-vers-Noréaz", "1747": "Corserey",
  "1748": "Torny-le-Grand", "1749": "Middes", "1752": "Villars-sur-Glâne",
  "1753": "Matran", "1754": "Avry-sur-Matran", "1756": "Onnens FR",
  "1757": "Noréaz", "1762": "Givisiez", "1763": "Granges-Paccot",
  "1772": "Grolley", "1773": "Léchelles", "1774": "Cousset",
  "1775": "Granges-de-Vesin", "1776": "Montagny-la-Ville",
  "1782": "Belfaux", "1783": "Pensier", "1784": "Courtepin",
  "1785": "Cressier FR", "1786": "Sugiez", "1787": "Môtier (Vully)",
  "1788": "Praz (Vully)", "1789": "Lugnorre",
  
  // Bulle et Gruyère
  "1630": "Bulle", "1631": "Bulle", "1632": "Riaz", "1633": "Marsens",
  "1634": "La Roche FR", "1635": "La Tour-de-Trême", "1636": "Broc",
  "1637": "Charmey (Gruyère)", "1638": "Morlon", "1642": "Sorens",
  "1643": "Gumefens", "1644": "Avry-devant-Pont", "1645": "Le Bry",
  "1646": "Echarlens", "1647": "Corbières", "1648": "Hauteville",
  "1649": "Pont-la-Ville", "1651": "Villarvolard", "1652": "Botterens",
  "1653": "Crésuz", "1654": "Cerniat FR", "1656": "Jaun",
  "1657": "Abländschen", "1658": "La Tine", "1659": "Flendruz",
  "1660": "Château-d'Oex", "1661": "Le Pâquier-Montbarry",
  "1663": "Epagny", "1663": "Gruyères", "1665": "Estavannens",
  "1666": "Grandvillard", "1667": "Enney", "1668": "Neirivue",
  "1669": "Albeuve", "1670": "Ursy", "1673": "Ecublens FR",
  "1674": "Vuarmarens", "1675": "Vauderens", "1676": "Chavannes-les-Forts",
  "1677": "Prez-vers-Siviriez", "1678": "Siviriez", "1679": "Villaraboud",
  "1680": "Romont FR", "1681": "Hennens", "1682": "Villars-Bramard",
  "1683": "Brenles", "1684": "Mézières FR", "1685": "Villariaz",
  "1686": "Grangettes-près-Romont", "1687": "Vuisternens-devant-Romont",
  "1688": "Lieffrens", "1689": "Le Châtelard-près-Romont",
  "1690": "Villaz-St-Pierre", "1691": "Villarimboud", "1692": "Massonnens",
  "1694": "Villarsiviriaux", "1695": "Rueyres-St-Laurent",
  "1696": "Vuisternens-en-Ogoz", "1697": "Les Ecasseys",
  
  // Morat et environs
  "1712": "Tafers", "1792": "Cordast", "1793": "Jeuss",
  "1794": "Salvenach", "1795": "Courlevon", "1796": "Courgevaux",
  "1797": "Münchenwiler",
  
  // Estavayer et Broye fribourgeoise
  "1470": "Estavayer-le-Lac", "1473": "Font", "1474": "Châbles FR",
  "1475": "Autavaux", "1482": "Cugy FR", "1483": "Frasses",
  "1484": "Aumont", "1485": "Nuvilly", "1486": "Vuissens", "1489": "Murist",
  
  // ============================================
  // CANTON DE BERNE (BE)
  // ============================================
  "3000": "Bern", "3001": "Bern", "3003": "Bern", "3004": "Bern",
  "3005": "Bern", "3006": "Bern", "3007": "Bern", "3008": "Bern",
  "3010": "Bern", "3011": "Bern", "3012": "Bern", "3013": "Bern",
  "3014": "Bern", "3015": "Bern", "3018": "Bern", "3019": "Bern",
  "3020": "Bern", "3027": "Bern", "3030": "Bern",
  "3032": "Hinterkappelen", "3033": "Wohlen b. Bern", "3034": "Murzelen",
  "3035": "Frauenkappelen", "3036": "Detligen", "3037": "Herrenschwanden",
  "3038": "Kirchlindach", "3042": "Ortschwaben", "3043": "Uettligen",
  "3044": "Innerberg", "3045": "Meikirch", "3046": "Wahlendorf",
  "3047": "Bremgarten b. Bern", "3048": "Worblaufen", "3049": "Säriswil",
  "3052": "Zollikofen", "3053": "Münchenbuchsee", "3054": "Schüpfen",
  "3063": "Ittigen", "3065": "Bolligen", "3066": "Stettlen",
  "3067": "Boll", "3068": "Utzigen", "3072": "Ostermundigen",
  "3073": "Gümligen", "3074": "Muri b. Bern", "3075": "Rüfenacht BE",
  "3076": "Worb", "3077": "Enggistein", "3078": "Richigen",
  "3082": "Schlosswil", "3083": "Trimstein", "3084": "Wabern",
  "3086": "Zimmerwald", "3088": "Rüeggisberg", "3095": "Spiegel b. Bern",
  "3096": "Oberbalm", "3097": "Liebefeld", "3098": "Köniz",
  "3099": "Rüti b. Riggisberg",
  
  // Biel/Bienne
  "2500": "Biel/Bienne", "2501": "Biel/Bienne", "2502": "Biel/Bienne",
  "2503": "Biel/Bienne", "2504": "Biel/Bienne", "2505": "Biel/Bienne",
  "2512": "Tüscherz-Alfermée", "2513": "Twann-Tüscherz",
  "2514": "Ligerz", "2515": "Prêles", "2516": "Lamboing",
  "2517": "Diesse", "2518": "Nods", "2520": "La Neuveville",
  "2525": "Le Landeron", "2532": "Macolin", "2533": "Evilard",
  "2534": "Orvin", "2535": "Frinvillier", "2536": "Plagne",
  "2537": "Vauffelin", "2538": "Romont BE", "2540": "Granges SO",
  "2542": "Pieterlen", "2543": "Lengnau BE", "2545": "Selzach",
  "2552": "Orpund", "2553": "Safnern", "2554": "Meinisberg",
  "2555": "Brügg BE", "2556": "Scheuren", "2557": "Studen BE",
  "2558": "Aegerten", "2560": "Nidau", "2562": "Port",
  "2563": "Ipsach", "2564": "Bellmund", "2565": "Jens",
  "2572": "Sutz-Lattrigen", "2575": "Täuffelen", "2576": "Lüscherz",
  "2577": "Finsterhennen",
  
  // Thun
  "3600": "Thun", "3601": "Thun", "3602": "Thun", "3603": "Thun",
  "3604": "Thun", "3607": "Thun", "3608": "Thun", "3609": "Thun",
  "3612": "Steffisburg", "3613": "Steffisburg", "3614": "Unterlangenegg",
  "3615": "Heimenschwand", "3616": "Schwarzenegg", "3617": "Fahrni b. Thun",
  "3618": "Süderen", "3619": "Eriz", "3622": "Homberg b. Thun",
  "3623": "Teuffenthal b. Thun", "3624": "Goldiwil (Thun)",
  "3625": "Heiligenschwendi", "3626": "Hünibach", "3627": "Heimberg",
  "3628": "Uttigen", "3629": "Kiesen", "3631": "Höfen b. Thun",
  "3632": "Niederstocken", "3633": "Amsoldingen", "3634": "Thierachern",
  "3635": "Uebeschi", "3636": "Längenbühl", "3638": "Pohlern",
  "3645": "Gwatt (Thun)", "3647": "Reutigen", "3652": "Hilterfingen",
  "3653": "Oberhofen am Thunersee", "3654": "Gunten", "3655": "Sigriswil",
  "3656": "Tschingel ob Gunten", "3657": "Schwanden (Sigriswil)",
  "3658": "Merligen",
  
  // Interlaken et Oberland
  "3800": "Interlaken", "3801": "Jungfraujoch", "3802": "Interlaken",
  "3803": "Beatenberg", "3804": "Habkern", "3805": "Goldswil b. Interlaken",
  "3806": "Bönigen b. Interlaken", "3807": "Iseltwald",
  "3812": "Wilderswil", "3813": "Saxeten", "3814": "Gsteigwiler",
  "3815": "Gündlischwand", "3816": "Lütschental", "3818": "Grindelwald",
  "3822": "Lauterbrunnen", "3823": "Wengen", "3824": "Stechelberg",
  "3825": "Mürren", "3826": "Gimmelwald", "3852": "Ringgenberg BE",
  "3853": "Niederried b. Interlaken", "3854": "Oberried am Brienzersee",
  "3855": "Brienz BE", "3856": "Brienzwiler", "3857": "Unterbach BE",
  "3858": "Hofstetten b. Brienz", "3860": "Meiringen", "3862": "Innertkirchen",
  "3863": "Gadmen", "3864": "Guttannen", "3900": "Brig",
  
  // ============================================
  // CANTON DE BÂLE-VILLE (BS) ET BÂLE-CAMPAGNE (BL)
  // ============================================
  "4000": "Basel", "4001": "Basel", "4002": "Basel", "4003": "Basel",
  "4004": "Basel", "4005": "Basel", "4009": "Basel", "4010": "Basel",
  "4011": "Basel", "4012": "Basel", "4013": "Basel", "4015": "Basel",
  "4016": "Basel", "4017": "Basel", "4018": "Basel", "4019": "Basel",
  "4020": "Basel", "4024": "Basel", "4025": "Basel", "4030": "Basel",
  "4031": "Basel", "4032": "Basel", "4051": "Basel", "4052": "Basel",
  "4053": "Basel", "4054": "Basel", "4055": "Basel", "4056": "Basel",
  "4057": "Basel", "4058": "Basel", "4059": "Basel",
  "4101": "Bruderholz", "4102": "Binningen", "4103": "Bottmingen",
  "4104": "Oberwil BL", "4105": "Biel-Benken BL", "4106": "Therwil",
  "4107": "Ettingen", "4108": "Witterswil", "4112": "Bättwil",
  "4114": "Hofstetten SO", "4115": "Mariastein", "4116": "Metzerlen",
  "4117": "Burg im Leimental", "4118": "Rodersdorf", "4123": "Allschwil",
  "4124": "Schönenbuch", "4125": "Riehen", "4126": "Bettingen",
  "4127": "Birsfelden", "4132": "Muttenz", "4133": "Pratteln",
  "4142": "Münchenstein", "4144": "Arlesheim", "4145": "Gempen",
  "4146": "Hochwald", "4147": "Aesch BL", "4148": "Pfeffingen",
  "4153": "Reinach BL", "4202": "Duggingen", "4203": "Grellingen",
  "4204": "Himmelried", "4206": "Seewen SO", "4207": "Bretzwil",
  "4208": "Nunningen", "4222": "Zwingen", "4223": "Blauen",
  "4224": "Nenzlingen", "4225": "Brislach", "4226": "Breitenbach",
  "4227": "Büsserach", "4228": "Erschwil", "4229": "Beinwil SO",
  "4232": "Fehren", "4233": "Meltingen", "4234": "Zullwil",
  "4242": "Laufen", "4243": "Dittingen", "4244": "Röschenz",
  "4245": "Kleinlützel", "4246": "Wahlen b. Laufen", "4247": "Grindel",
  "4252": "Himmelried", "4253": "Liesberg", "4254": "Liesberg Dorf",
  "4302": "Augst BL", "4303": "Kaiseraugst", "4304": "Giebenach",
  "4305": "Olsberg", "4310": "Rheinfelden", "4312": "Magden",
  "4313": "Möhlin", "4314": "Zeiningen", "4315": "Zuzgen",
  "4316": "Hellikon", "4317": "Wegenstetten", "4322": "Mumpf",
  "4323": "Wallbach", "4324": "Obermumpf", "4325": "Schupfart",
  "4332": "Stein AG", "4333": "Münchwilen AG", "4334": "Sisseln AG",
  "4402": "Frenkendorf", "4410": "Liestal", "4411": "Seltisberg",
  "4412": "Nuglar-St. Pantaleon", "4413": "Büren SO", "4414": "Füllinsdorf",
  "4415": "Lausen", "4416": "Bubendorf", "4417": "Ziefen",
  "4418": "Reigoldswil", "4419": "Lupsingen", "4422": "Arisdorf",
  "4423": "Hersberg", "4424": "Arboldswil", "4425": "Titterten",
  "4426": "Lauwil", "4431": "Bennwil", "4432": "Lampenberg",
  "4433": "Ramlinsburg", "4434": "Hölstein", "4435": "Niederdorf",
  "4436": "Oberdorf BL", "4437": "Waldenburg", "4438": "Langenbruck",
  "4441": "Thürnen", "4442": "Diepflingen", "4443": "Wittinsburg",
  "4444": "Rümlingen", "4445": "Häfelfingen", "4446": "Buckten",
  "4447": "Känerkinden", "4448": "Läufelfingen", "4450": "Sissach",
  "4451": "Wintersingen", "4452": "Itingen", "4453": "Nusshof",
  "4455": "Zunzgen", "4456": "Tenniken", "4457": "Diegten",
  "4458": "Eptingen", "4460": "Gelterkinden", "4461": "Böckten",
  "4462": "Rickenbach BL", "4463": "Buus", "4464": "Maisprach",
  "4465": "Hemmiken", "4466": "Ormalingen", "4467": "Rothenfluh",
  "4468": "Kienberg", "4469": "Anwil",
  
  // ============================================
  // CANTON DE ZURICH (ZH)
  // ============================================
  "8000": "Zürich", "8001": "Zürich", "8002": "Zürich", "8003": "Zürich",
  "8004": "Zürich", "8005": "Zürich", "8006": "Zürich", "8008": "Zürich",
  "8010": "Zürich", "8011": "Zürich", "8012": "Zürich", "8015": "Zürich",
  "8017": "Zürich", "8018": "Zürich", "8019": "Zürich", "8020": "Zürich",
  "8021": "Zürich", "8022": "Zürich", "8023": "Zürich", "8024": "Zürich",
  "8025": "Zürich", "8026": "Zürich", "8027": "Zürich", "8028": "Zürich",
  "8029": "Zürich", "8030": "Zürich", "8031": "Zürich", "8032": "Zürich",
  "8033": "Zürich", "8034": "Zürich", "8035": "Zürich", "8036": "Zürich",
  "8037": "Zürich", "8038": "Zürich", "8039": "Zürich", "8040": "Zürich",
  "8041": "Zürich", "8042": "Zürich", "8043": "Zürich", "8044": "Zürich",
  "8045": "Zürich", "8046": "Zürich", "8047": "Zürich", "8048": "Zürich",
  "8049": "Zürich", "8050": "Zürich", "8051": "Zürich", "8052": "Zürich",
  "8053": "Zürich", "8055": "Zürich", "8057": "Zürich", "8058": "Zürich-Flughafen",
  "8060": "Zürich", "8063": "Zürich", "8064": "Zürich", "8099": "Zürich",
  "8102": "Oberengstringen", "8103": "Unterengstringen", "8104": "Weiningen ZH",
  "8105": "Regensdorf", "8106": "Adlikon b. Regensdorf", "8107": "Buchs ZH",
  "8108": "Dällikon", "8109": "Kloster Fahr", "8112": "Otelfingen",
  "8113": "Boppelsen", "8114": "Dänikon ZH", "8115": "Hüttikon",
  "8117": "Fällanden", "8118": "Pfaffhausen", "8121": "Benglen",
  "8122": "Binz", "8123": "Ebmatingen", "8124": "Maur",
  "8125": "Zollikerberg", "8126": "Zumikon", "8127": "Forch",
  "8132": "Egg b. Zürich", "8133": "Esslingen", "8134": "Adliswil",
  "8135": "Langnau am Albis", "8136": "Gattikon", "8142": "Uitikon Waldegg",
  "8143": "Stallikon", "8152": "Glattbrugg", "8153": "Rümlang",
  "8154": "Oberglatt ZH", "8155": "Niederhasli", "8156": "Oberhasli",
  "8157": "Dielsdorf", "8158": "Regensberg", "8162": "Steinmaur",
  "8164": "Bachs", "8165": "Schöfflisdorf", "8166": "Niederweningen",
  "8172": "Niederglatt ZH", "8173": "Neerach", "8174": "Stadel b. Niederglatt",
  "8175": "Windlach", "8180": "Bülach", "8181": "Höri",
  "8182": "Hochfelden", "8183": "Bülach", "8184": "Bachenbülach",
  "8185": "Winkel", "8187": "Weiach", "8192": "Zweidlen-Glattfelden",
  "8193": "Eglisau", "8194": "Hüntwangen", "8195": "Wasterkingen",
  "8196": "Wil ZH", "8197": "Rafz",
  
  // Winterthur
  "8400": "Winterthur", "8401": "Winterthur", "8402": "Winterthur",
  "8404": "Winterthur", "8405": "Winterthur", "8406": "Winterthur",
  "8408": "Winterthur", "8409": "Winterthur", "8410": "Winterthur",
  "8411": "Winterthur", "8412": "Aesch (Neftenbach)", "8413": "Neftenbach",
  "8414": "Buch am Irchel", "8415": "Berg am Irchel", "8416": "Flaach",
  "8418": "Schlatt b. Winterthur", "8421": "Dättlikon", "8422": "Pfungen",
  "8424": "Embrach", "8425": "Oberembrach", "8426": "Lufingen",
  "8427": "Rorbas", "8428": "Teufen ZH",
  
  // ============================================
  // CANTON DU VALAIS (VS)
  // ============================================
  // Bas-Valais
  "1890": "St-Maurice", "1891": "Vérossaz", "1892": "Lavey-Village",
  "1893": "Muraz (Collombey)", "1895": "Vionnaz", "1896": "Vouvry",
  "1897": "Le Bouveret", "1898": "St-Gingolph",
  "1902": "Evionnaz", "1903": "Collonges", "1904": "Vernayaz",
  "1905": "Dorénaz", "1906": "Charrat", "1907": "Saxon",
  "1908": "Riddes", "1911": "Ovronnaz", "1912": "Leytron",
  "1913": "Saillon", "1914": "Isérables", "1918": "La Tzoumaz",
  "1920": "Martigny", "1921": "Martigny-Croix", "1922": "Salvan",
  "1923": "Les Marécottes", "1925": "Le Châtelard VS", "1926": "Fully",
  "1927": "Chemin", "1928": "Ravoire", "1929": "Trient",
  "1933": "Sembrancher", "1934": "Le Châble VS", "1936": "Verbier",
  "1937": "Orsières", "1938": "Champex-Lac", "1941": "Vollèges",
  "1942": "Levron", "1943": "Praz-de-Fort", "1944": "La Fouly VS",
  "1945": "Liddes", "1946": "Bourg-St-Pierre", "1947": "Versegères",
  "1948": "Lourtier",
  
  // Sion et environs
  "1950": "Sion", "1951": "Sion", "1958": "Uvrier", "1961": "Vernamiège",
  "1962": "Pont-de-la-Morge (Sion)", "1963": "Vétroz", "1964": "Conthey",
  "1965": "Savièse", "1966": "Ayent", "1967": "Bramois",
  "1968": "Mase", "1969": "St-Martin VS", "1971": "Grimisuat",
  "1972": "Anzère", "1973": "Nax", "1974": "Arbaz", "1975": "St-Séverin",
  "1976": "Erde", "1977": "Icogne", "1978": "Lens", "1981": "Vex",
  "1982": "Euseigne", "1983": "Evolène", "1984": "Les Haudères",
  "1985": "La Sage", "1986": "Arolla", "1987": "Hérémence",
  "1988": "Les Collons", "1991": "Salins", "1992": "Les Agettes",
  "1993": "Veysonnaz", "1994": "Aproz (Nendaz)", "1996": "Basse-Nendaz",
  "1997": "Haute-Nendaz",
  
  // Sierre et environs
  "3960": "Sierre", "3961": "Vissoie", "3963": "Crans-Montana",
  "3965": "Chippis", "3966": "Chalais", "3967": "Vercorin",
  "3968": "Veyras", "3970": "Salgesch", "3971": "Chermignon",
  "3972": "Miège", "3973": "Venthône", "3974": "Mollens VS",
  "3975": "Randogne", "3976": "Noës", "3977": "Granges VS",
  "3978": "Flanthey", "3979": "Grône",
  
  // Haut-Valais
  "3900": "Brig", "3901": "Rothwald", "3902": "Glis", "3903": "Birgisch",
  "3904": "Naters", "3905": "Saas-Almagell", "3906": "Saas-Fee",
  "3907": "Simplon Hospiz", "3908": "Saas-Balen", "3910": "Saas-Grund",
  "3911": "Ried-Brig", "3912": "Termen", "3913": "Rosswald",
  "3914": "Blatten b. Naters", "3916": "Ferden", "3917": "Kippel",
  "3918": "Wiler (Lötschen)", "3919": "Blatten (Lötschen)",
  "3920": "Zermatt", "3922": "Stalden VS", "3923": "Törbel",
  "3924": "St. Niklaus VS", "3925": "Grächen", "3926": "Embd",
  "3927": "Herbriggen", "3928": "Randa", "3929": "Täsch",
  "3930": "Visp", "3931": "Lalden", "3932": "Visperterminen",
  "3933": "Staldenried", "3934": "Zeneggen", "3935": "Bürchen",
  "3937": "Baltschieder", "3938": "Ausserberg", "3939": "Eggerberg",
  "3940": "Steg VS", "3942": "Niedergesteln", "3943": "Eischoll",
  "3944": "Unterbäch VS", "3945": "Gampel", "3946": "Turtmann",
  "3947": "Ergisch", "3948": "Unterems", "3949": "Hohtenn",
  "3952": "Susten", "3953": "Leuk Stadt", "3954": "Leukerbad",
  "3955": "Albinen", "3956": "Guttet-Feschel", "3957": "Bratsch",
  "3982": "Bitsch", "3983": "Mörel", "3984": "Fieschertal",
  "3985": "Münster VS", "3986": "Ried-Mörel", "3987": "Riederalp",
  "3988": "Ulrichen", "3989": "Blitzingen", "3991": "Betten",
  "3992": "Bettmeralp", "3993": "Grengiols", "3994": "Lax",
  "3995": "Ernen", "3996": "Binn", "3997": "Bellwald",
  "3998": "Gluringen", "3999": "Oberwald",
  
  // ============================================
  // CANTON DU TESSIN (TI)
  // ============================================
  "6500": "Bellinzona", "6501": "Bellinzona", "6502": "Bellinzona",
  "6503": "Bellinzona", "6512": "Giubiasco", "6513": "Monte Carasso",
  "6514": "Sementina", "6515": "Gudo", "6516": "Cugnasco",
  "6517": "Arbedo", "6518": "Gorduno", "6523": "Preonzo",
  "6524": "Moleno", "6525": "Gnosca", "6526": "Prosito",
  "6527": "Lodrino", "6528": "Camorino", "6532": "Castione",
  "6533": "Lumino", "6534": "S. Vittore", "6535": "Roveredo GR",
  "6537": "Grono", "6538": "Verdabbio", "6540": "Castaneda",
  "6541": "Santa Maria in Calanca", "6542": "Buseno", "6543": "Arvigo",
  "6544": "Braggio", "6545": "Selma", "6546": "Cauco",
  "6547": "Augio", "6548": "Rossa", "6549": "Laura",
  "6556": "Leggia", "6557": "Cama", "6558": "Lostallo",
  "6562": "Soazza", "6563": "Mesocco", "6565": "S. Bernardino",
  
  // Locarno
  "6600": "Locarno", "6601": "Locarno", "6602": "Muralto",
  "6604": "Locarno", "6605": "Locarno", "6611": "Arcegno",
  "6612": "Ascona", "6613": "Porto Ronco", "6614": "Brissago",
  "6616": "Losone", "6618": "Arcegno", "6622": "Ronco sopra Ascona",
  "6631": "Corippo", "6632": "Vogorno", "6633": "Lavertezzo",
  "6634": "Brione (Verzasca)", "6635": "Gerra (Verzasca)",
  "6636": "Frasco", "6637": "Sonogno", "6644": "Orselina",
  "6645": "Brione sopra Minusio", "6646": "Contra", "6647": "Mergoscia",
  "6648": "Minusio", "6652": "Tegna", "6653": "Verscio",
  "6654": "Cavigliano", "6655": "Intragna", "6656": "Golino",
  "6657": "Palagnedra", "6658": "Borgnone", "6659": "Camedo",
  "6661": "Auressio", "6662": "Russo", "6663": "Comologno",
  "6664": "Vergeletto", "6670": "Avegno", "6672": "Gordevio",
  "6673": "Maggia", "6674": "Someo", "6675": "Cevio",
  "6676": "Bignasco", "6677": "Moghegno", "6678": "Coglio",
  "6682": "Linescio", "6683": "Cerentino", "6684": "Campo (Vallemaggia)",
  "6685": "Bosco/Gurin", "6690": "S. Nazzaro", "6691": "Caviano",
  "6692": "Piazzogna", "6693": "Brontallo", "6694": "Prato-Sornico",
  "6695": "Peccia", "6696": "Fusio",
  
  // Lugano
  "6900": "Lugano", "6901": "Lugano", "6902": "Lugano",
  "6903": "Lugano", "6904": "Lugano", "6906": "Lugano",
  "6907": "Lugano", "6908": "Massagno", "6910": "Lugano",
  "6911": "Campione d'Italia", "6912": "Lugano", "6913": "Carabbia",
  "6914": "Carona", "6915": "Pambio-Noranco", "6916": "Grancia",
  "6917": "Barbengo", "6918": "Figino", "6919": "Carabietta",
  "6921": "Vico Morcote", "6922": "Morcote", "6924": "Sorengo",
  "6925": "Gentilino", "6926": "Montagnola", "6927": "Agra",
  "6928": "Manno", "6929": "Gravesano", "6930": "Bedano",
  "6932": "Breganzona", "6933": "Muzzano", "6934": "Bioggio",
  "6935": "Bosco Luganese", "6936": "Cademario", "6937": "Breno",
  "6938": "Vezio", "6939": "Arosio", "6942": "Savosa",
  "6943": "Vezia", "6944": "Cureglia", "6945": "Origlio",
  "6946": "Ponte Capriasca", "6947": "Vaglio", "6948": "Porza",
  "6949": "Comano", "6950": "Tesserete", "6951": "Insone",
  "6952": "Canobbio", "6953": "Lugaggia", "6954": "Sala Capriasca",
  "6955": "Cagiallo", "6956": "Lopagno", "6957": "Roveredo TI",
  "6958": "Bidogno", "6959": "Piandera Paese", "6960": "Odogno",
  "6962": "Viganello", "6963": "Pregassona", "6964": "Davesco-Soragno",
  "6965": "Cadro", "6966": "Villa Luganese", "6967": "Dino",
  "6968": "Sonvico", "6974": "Aldesago", "6976": "Castagnola",
  "6977": "Ruvigliana", "6978": "Gandria", "6979": "Brè sopra Lugano",
  "6980": "Castelrotto", "6981": "Bombinasco", "6982": "Agno",
  "6983": "Magliaso", "6984": "Pura", "6986": "Curio",
  "6987": "Caslano", "6988": "Ponte Tresa", "6989": "Purasca",
  "6990": "Cassina d'Agno", "6991": "Neggio", "6992": "Vernate",
  "6993": "Iseo", "6994": "Aranno", "6995": "Madonna del Piano",
  "6996": "Ponte Cremenaga", "6997": "Sessa", "6998": "Monteggio",
  "6999": "Astano",
  
  // Mendrisio et Chiasso
  "6802": "Rivera", "6803": "Camignolo", "6804": "Bironico",
  "6805": "Mezzovico", "6806": "Sigirino", "6807": "Taverne",
  "6808": "Torricella", "6809": "Medeglia", "6810": "Isone",
  "6814": "Lamone", "6815": "Melide", "6816": "Bissone",
  "6817": "Maroggia", "6818": "Melano", "6821": "Rovio",
  "6822": "Arogno", "6823": "Pugerna", "6825": "Capolago",
  "6826": "Riva San Vitale", "6827": "Brusino Arsizio",
  "6828": "Balerna", "6830": "Chiasso", "6832": "Pedrinate",
  "6833": "Vacallo", "6834": "Morbio Inferiore", "6835": "Morbio Superiore",
  "6837": "Bruzella", "6838": "Cabbio", "6839": "Sagno",
  "6850": "Mendrisio", "6852": "Genestrerio", "6853": "Ligornetto",
  "6854": "S. Pietro", "6855": "Stabio", "6862": "Rancate",
  "6863": "Besazio", "6864": "Arzo", "6865": "Tremona",
  "6866": "Meride", "6872": "Salorino", "6873": "Corteglia",
  "6874": "Castel San Pietro", "6875": "Monte", "6877": "Coldrerio",
  
  // Biasca et Valle Leventina
  "6702": "Claro", "6703": "Osogna", "6705": "Cresciano",
  "6706": "Iragna", "6707": "Biasca", "6710": "Biasca",
  "6714": "Semione", "6715": "Dongio", "6716": "Acquarossa",
  "6717": "Dangio-Torre", "6718": "Olivone", "6719": "Aquila",
  "6720": "Campo (Blenio)", "6721": "Motto (Blenio)",
  "6722": "Corzoneso", "6723": "Prugiasco", "6724": "Ponto Valentino",
  "6742": "Pollegio", "6743": "Bodio TI", "6744": "Personico",
  "6745": "Giornico", "6746": "Lavorgo", "6747": "Chironico",
  "6748": "Anzonico", "6749": "Sobrio", "6760": "Faido",
  "6763": "Mairengo", "6764": "Chiggiogna", "6772": "Rodi-Fiesso",
  "6773": "Prato (Leventina)", "6774": "Dalpe", "6775": "Ambrì",
  "6776": "Piotta", "6777": "Quinto", "6780": "Airolo", "6781": "Bedretto",
  
  // ============================================
  // AUTRES CANTONS
  // ============================================
  // Lucerne (LU)
  "6000": "Luzern", "6002": "Luzern", "6003": "Luzern", "6004": "Luzern",
  "6005": "Luzern", "6006": "Luzern", "6007": "Luzern", "6009": "Luzern",
  "6010": "Kriens", "6011": "Kriens", "6012": "Obernau", "6013": "Eigenthal",
  "6014": "Luzern", "6015": "Luzern", "6016": "Hellbühl", "6017": "Ruswil",
  "6018": "Buttisholz", "6019": "Sigigen", "6020": "Emmenbrücke",
  "6021": "Emmenbrücke", "6022": "Grosswangen", "6023": "Rothenburg",
  "6024": "Hildisrieden", "6025": "Neudorf", "6026": "Rain",
  "6027": "Römerswil LU", "6028": "Herlisberg", "6030": "Ebikon",
  "6031": "Ebikon", "6032": "Emmen", "6033": "Buchrain", "6034": "Inwil",
  "6035": "Perlen", "6036": "Dierikon", "6037": "Root", "6038": "Gisikon",
  "6039": "Root Längenbold", "6042": "Dietwil", "6043": "Adligenswil",
  "6044": "Udligenswil", "6045": "Meggen", "6047": "Kastanienbaum",
  "6048": "Horw", "6052": "Hergiswil NW", "6053": "Alpnachstad",
  "6055": "Alpnach Dorf", "6056": "Kägiswil", "6060": "Sarnen",
  "6062": "Wilen (Sarnen)", "6063": "Stalden (Sarnen)", "6064": "Kerns",
  "6066": "St. Niklausen OW", "6067": "Melchtal", "6068": "Melchsee-Frutt",
  "6072": "Sachseln", "6073": "Flüeli-Ranft", "6074": "Giswil",
  "6078": "Lungern", "6083": "Hasliberg Hohfluh",
  
  // Aarau et Argovie (AG)
  "5000": "Aarau", "5001": "Aarau", "5004": "Aarau", "5012": "Schönenwerd",
  "5013": "Niedergösgen", "5014": "Gretzenbach", "5015": "Erlinsbach SO",
  "5017": "Barmelweid", "5018": "Erlinsbach AG", "5022": "Rombach",
  "5023": "Biberstein", "5024": "Küttigen", "5025": "Asp",
  "5026": "Densbüren", "5027": "Herznach", "5028": "Ueken",
  "5032": "Aarau Rohr", "5033": "Buchs AG", "5034": "Suhr",
  "5035": "Unterentfelden", "5036": "Oberentfelden", "5037": "Muhen",
  "5040": "Schöftland", "5042": "Hirschthal", "5043": "Holziken",
  "5044": "Schlossrued", "5046": "Schmiedrued", "5053": "Staffelbach",
  "5054": "Moosleerau", "5056": "Attelwil", "5057": "Reitnau",
  "5058": "Wiliberg", "5062": "Oberhof", "5063": "Wölflinswil",
  "5064": "Wittnau", "5070": "Frick", "5072": "Oeschgen",
  "5073": "Gipf-Oberfrick", "5074": "Eiken", "5075": "Hornussen",
  "5076": "Bözen", "5077": "Elfingen", "5078": "Effingen",
  "5079": "Zeihen", "5080": "Laufenburg", "5082": "Kaisten",
  "5083": "Ittenthal", "5084": "Rheinsulz", "5085": "Sulz AG",
  "5102": "Rupperswil", "5103": "Wildegg", "5105": "Auenstein",
  "5106": "Veltheim AG", "5107": "Schinznach Dorf", "5108": "Oberflachs",
  "5112": "Thalheim AG", "5113": "Holderbank AG", "5116": "Schinznach Bad",
  
  // St-Gall (SG)
  "9000": "St. Gallen", "9001": "St. Gallen", "9004": "St. Gallen",
  "9006": "St. Gallen", "9007": "St. Gallen", "9008": "St. Gallen",
  "9009": "St. Gallen", "9010": "St. Gallen", "9011": "St. Gallen",
  "9012": "St. Gallen", "9013": "St. Gallen", "9014": "St. Gallen",
  "9015": "St. Gallen", "9016": "St. Gallen", "9020": "St. Gallen",
  "9023": "St. Gallen", "9024": "St. Gallen", "9025": "St. Gallen",
  "9026": "St. Gallen", "9027": "St. Gallen", "9028": "St. Gallen",
  "9029": "St. Gallen", "9030": "Abtwil SG", "9032": "Engelburg",
  "9033": "Untereggen", "9034": "Eggersriet", "9035": "Grub AR",
  "9036": "Grub SG", "9037": "Speicherschwendi", "9038": "Rehetobel",
  "9042": "Speicher", "9043": "Trogen", "9044": "Wald AR",
  "9050": "Appenzell", "9052": "Niederteufen", "9053": "Teufen AR",
  "9054": "Haslen AI", "9055": "Bühler", "9056": "Gais",
  "9057": "Weissbad", "9058": "Brülisau", "9062": "Lustmühle",
  "9063": "Stein AR", "9064": "Hundwil", "9100": "Herisau",
  "9102": "Herisau", "9103": "Schwellbrunn", "9104": "Waldstatt",
  "9105": "Schönengrund", "9107": "Urnäsch", "9108": "Gonten",
  "9112": "Schachen b. Herisau", "9113": "Degersheim", "9114": "Hoffeld",
  "9115": "Dicken", "9116": "Wolfertswil", "9122": "Mogelsberg",
  "9123": "Nassen", "9125": "Brunnadern", "9126": "Necker",
  "9127": "St. Peterzell",
  
  // Grisons (GR)
  "7000": "Chur", "7001": "Chur", "7002": "Chur", "7003": "Chur",
  "7004": "Chur", "7007": "Chur", "7012": "Felsberg", "7013": "Domat/Ems",
  "7014": "Trin", "7015": "Tamins", "7016": "Trin Mulin",
  "7017": "Flims Dorf", "7018": "Flims Waldhaus", "7019": "Fidaz",
  "7023": "Haldenstein", "7024": "Malans GR", "7026": "Maladers",
  "7027": "Castiel", "7028": "St. Peter", "7029": "Peist",
  "7031": "Laax GR", "7032": "Laax GR 2", "7050": "Arosa",
  "7056": "Molinis", "7057": "Langwies", "7058": "Litzirüti",
  "7062": "Passugg-Araschgen", "7063": "Praden", "7064": "Tschiertschen",
  "7074": "Malix", "7075": "Churwalden", "7076": "Parpan",
  "7077": "Valbella", "7078": "Lenzerheide/Lai",
  "7130": "Ilanz", "7132": "Vals", "7134": "Obersaxen Meierhof",
  "7138": "Surcuolm", "7140": "Luven", "7141": "Luven",
  "7142": "Cumbel", "7143": "Morissen", "7144": "Vella",
  "7145": "Degen", "7146": "Vattiz", "7147": "Vignogn",
  "7148": "Lumbrein", "7149": "Vrin", "7151": "Schluein",
  "7152": "Sagogn", "7153": "Falera", "7154": "Ruschein",
  "7155": "Ladir", "7156": "Pigniu", "7157": "Siat",
  "7158": "Waltensburg/Vuorz", "7159": "Andiast", "7162": "Tavanasa",
  "7163": "Danis-Tavanasa", "7164": "Dardin", "7165": "Breil/Brigels",
  "7166": "Trun", "7167": "Zignau", "7168": "Schlans",
  "7172": "Rabius", "7173": "Surrein", "7174": "S. Benedetg",
  "7175": "Sumvitg", "7176": "Cumpadials", "7180": "Disentis/Mustér",
  "7182": "Cavardiras", "7183": "Mumpé Medel", "7184": "Curaglia",
  "7185": "Platta", "7186": "Segnas", "7187": "Camischolas",
  "7188": "Sedrun", "7189": "Rueras",
  "7270": "Davos Platz", "7272": "Davos Clavadel", "7276": "Davos Frauenkirch",
  "7277": "Davos Glaris", "7278": "Davos Monstein", "7500": "St. Moritz",
  "7502": "Bever", "7503": "Samedan", "7504": "Pontresina",
  "7505": "Celerina/Schlarigna", "7512": "Champfèr", "7513": "Silvaplana",
  "7514": "Sils/Segl Maria", "7515": "Sils/Segl Baselgia",
  "7516": "Maloja", "7517": "Plaun da Lej", "7522": "La Punt-Chamues-ch",
  "7523": "Madulain", "7524": "Zuoz", "7525": "S-chanf",
  "7526": "Cinuos-chel", "7527": "Brail", "7530": "Zernez",
  "7532": "Tschierv", "7533": "Fuldera", "7534": "Lü",
  "7535": "Valchava", "7536": "Sta. Maria Val Müstair",
  "7537": "Müstair", "7542": "Susch", "7543": "Lavin",
  "7545": "Guarda", "7546": "Ardez", "7550": "Scuol",
  
  // Soleure (SO)
  "4500": "Solothurn", "4501": "Solothurn", "4502": "Solothurn",
  "4503": "Solothurn", "4509": "Solothurn", "4512": "Bellach",
  "4513": "Langendorf", "4514": "Lommiswil", "4515": "Oberdorf SO",
  "4522": "Rüttenen", "4523": "Niederwil SO", "4524": "Günsberg",
  "4525": "Balm b. Günsberg", "4528": "Zuchwil", "4532": "Feldbrunnen",
  "4533": "Riedholz", "4534": "Flumenthal", "4535": "Hubersdorf",
  "4536": "Attiswil", "4537": "Wiedlisbach", "4538": "Oberbipp",
  "4539": "Farnern", "4542": "Luterbach", "4543": "Deitingen",
  "4545": "Recherswil", "4552": "Derendingen", "4553": "Subingen",
  "4554": "Etziken", "4556": "Aeschi SO", "4557": "Horriwil",
  "4558": "Heinrichswil", "4562": "Biberist", "4563": "Gerlafingen",
  "4564": "Obergerlafingen", "4565": "Recherswil", "4566": "Kriegstetten",
  
  // Schaffhouse (SH)
  "8200": "Schaffhausen", "8201": "Schaffhausen", "8202": "Schaffhausen",
  "8203": "Schaffhausen", "8204": "Schaffhausen", "8205": "Schaffhausen",
  "8207": "Schaffhausen", "8208": "Schaffhausen", "8212": "Neuhausen am Rheinfall",
  "8213": "Neunkirch", "8214": "Gächlingen", "8215": "Hallau",
  "8216": "Oberhallau", "8217": "Wilchingen", "8218": "Osterfingen",
  "8219": "Trasadingen", "8222": "Beringen", "8223": "Guntmadingen",
  "8224": "Löhningen", "8225": "Siblingen", "8226": "Schleitheim",
  "8228": "Beggingen", "8231": "Hemmental", "8232": "Merishausen",
  "8233": "Bargen SH", "8234": "Stetten SH", "8235": "Lohn SH",
  "8236": "Opfertshofen SH", "8239": "Dörflingen", "8240": "Thayngen",
  "8241": "Barzheim", "8242": "Hofen SH", "8243": "Altdorf SH",
  "8245": "Feuerthalen", "8246": "Langwiesen", "8247": "Flurlingen",
  "8248": "Uhwiesen", "8252": "Schlatt TG", "8253": "Diessenhofen",
  "8254": "Basadingen", "8255": "Schlattingen", "8259": "Kaltenbach",
  "8260": "Stein am Rhein", "8261": "Hemishofen", "8262": "Ramsen",
  "8263": "Buch SH", "8264": "Eschenz", "8265": "Mammern",
  "8266": "Steckborn", "8267": "Berlingen", "8268": "Mannenbach-Salenstein",
  "8269": "Fruthwilen",
  
  // Thurgovie (TG)
  "8500": "Frauenfeld", "8501": "Frauenfeld", "8502": "Frauenfeld",
  "8503": "Frauenfeld", "8505": "Pfyn", "8506": "Lanzenneunforn",
  "8507": "Hörhausen", "8508": "Homburg", "8510": "Frauenfeld",
  "8512": "Lustdorf", "8514": "Amlikon-Bissegg", "8522": "Häuslenen",
  "8523": "Hagenbuch", "8524": "Uesslingen", "8525": "Niederneunforn",
  "8526": "Oberneunforn", "8532": "Weiningen TG", "8535": "Herdern",
  "8536": "Hüttwilen", "8537": "Nussbaumen TG", "8542": "Wiesendangen",
  "8543": "Bertschikon", "8544": "Attikon", "8545": "Rickenbach Sulz",
  "8546": "Islikon", "8547": "Gachnang", "8548": "Ellikon an der Thur",
  "8552": "Felben-Wellhausen", "8553": "Hüttlingen", "8554": "Müllheim-Wigoltingen",
  "8555": "Müllheim Dorf", "8556": "Wigoltingen", "8558": "Raperswilen",
  "8560": "Märstetten", "8561": "Ottoberg", "8564": "Engwilen",
  "8565": "Hugelshofen", "8566": "Dotnacht", "8570": "Weinfelden",
  "8572": "Berg TG", "8573": "Siegershausen", "8574": "Illighausen",
  "8575": "Bürglen TG", "8576": "Mauren TG", "8577": "Schönholzerswilen",
  "8580": "Amriswil", "8581": "Schocherswil", "8582": "Dozwil",
  "8583": "Sulgen", "8584": "Leimbach TG", "8585": "Langrickenbach",
  "8586": "Andwil TG", "8587": "Oberaach", "8588": "Zihlschlacht",
  "8590": "Romanshorn", "8592": "Uttwil", "8593": "Kesswil",
  "8594": "Güttingen", "8595": "Altnau", "8596": "Scherzingen",
  "8597": "Landschlacht", "8598": "Bottighofen", "8599": "Salmsach",
  
  // Zoug (ZG)
  "6300": "Zug", "6301": "Zug", "6302": "Zug", "6303": "Zug",
  "6304": "Zug", "6310": "Zug", "6312": "Steinhausen",
  "6313": "Menzingen", "6314": "Unterägeri", "6315": "Oberägeri",
  "6317": "Oberwil b. Zug", "6318": "Walchwil", "6319": "Allenwinden",
  "6330": "Cham", "6331": "Hünenberg", "6332": "Hagendorn",
  "6333": "Hünenberg See", "6340": "Baar", "6341": "Baar",
  "6343": "Rotkreuz", "6344": "Meierskappel", "6345": "Neuheim",
  "6349": "Risch",
  
  // Schwyz (SZ)
  "6402": "Merlischachen", "6403": "Küssnacht am Rigi", "6404": "Greppen",
  "6405": "Immensee", "6410": "Goldau", "6414": "Oberarth",
  "6415": "Arth", "6416": "Steinerberg", "6417": "Sattel",
  "6418": "Rothenthurm", "6422": "Steinen", "6423": "Seewen SZ",
  "6424": "Lauerz", "6430": "Schwyz", "6432": "Rickenbach SZ",
  "6433": "Stoos SZ", "6434": "Illgau", "6436": "Muotathal",
  "6438": "Ibach", "6440": "Brunnen", "6441": "Rütli",
  "6442": "Gersau", "6443": "Morschach", "6452": "Riemenstalden",
  "6454": "Flüelen", "6460": "Altdorf UR", "6461": "Isenthal",
  "6462": "Seedorf UR", "6463": "Bürglen UR", "6464": "Spiringen",
  "6465": "Unterschächen", "6466": "Bauen", "6467": "Schattdorf",
  "6468": "Attinghausen", "6469": "Haldi b. Schattdorf",
  "6472": "Erstfeld", "6473": "Silenen", "6474": "Amsteg",
  "6475": "Bristen", "6476": "Intschi", "6482": "Gurtnellen",
  "6484": "Wassen UR", "6485": "Meien", "6487": "Göschenen",
  "6490": "Andermatt", "6491": "Realp", "6493": "Hospental",
  
  // Nidwald et Obwald (NW/OW)
  "6052": "Hergiswil NW", "6362": "Stansstad", "6363": "Obbürgen",
  "6365": "Kehrsiten", "6370": "Stans", "6371": "Stans",
  "6372": "Ennetmoos", "6373": "Ennetbürgen", "6374": "Buochs",
  "6375": "Beckenried", "6376": "Emmetten", "6377": "Seelisberg",
  "6382": "Büren NW", "6383": "Dallenwil", "6386": "Wolfenschiessen",
  "6387": "Oberrickenbach", "6388": "Grafenort",
  "6053": "Alpnachstad", "6055": "Alpnach Dorf", "6056": "Kägiswil",
  "6060": "Sarnen", "6061": "Sarnen", "6062": "Wilen (Sarnen)",
  "6063": "Stalden (Sarnen)", "6064": "Kerns", "6066": "St. Niklausen OW",
  "6067": "Melchtal", "6068": "Melchsee-Frutt", "6072": "Sachseln",
  "6073": "Flüeli-Ranft", "6074": "Giswil", "6078": "Lungern",
  
  // Uri (UR)
  "6454": "Flüelen", "6460": "Altdorf UR", "6461": "Isenthal",
  "6462": "Seedorf UR", "6463": "Bürglen UR", "6464": "Spiringen",
  "6465": "Unterschächen", "6466": "Bauen", "6467": "Schattdorf",
  "6468": "Attinghausen", "6469": "Haldi b. Schattdorf",
  "6472": "Erstfeld", "6473": "Silenen", "6474": "Amsteg",
  "6475": "Bristen", "6476": "Intschi", "6482": "Gurtnellen",
  "6484": "Wassen UR", "6485": "Meien", "6487": "Göschenen",
  "6490": "Andermatt", "6491": "Realp", "6493": "Hospental",
  
  // Glaris (GL)
  "8750": "Glarus", "8752": "Näfels", "8753": "Mollis",
  "8754": "Netstal", "8755": "Ennenda", "8756": "Mitlödi",
  "8757": "Filzbach", "8758": "Obstalden", "8759": "Netstal",
  "8762": "Schwanden GL", "8765": "Engi", "8766": "Matt",
  "8767": "Elm", "8772": "Nidfurn", "8773": "Haslen GL",
  "8774": "Leuggelbach", "8775": "Luchsingen", "8777": "Diesbach GL",
  "8782": "Rüti GL", "8783": "Linthal", "8784": "Braunwald",
  
  // Appenzell Rhodes-Extérieures et Intérieures (AR/AI)
  "9035": "Grub AR", "9036": "Grub SG", "9037": "Speicherschwendi",
  "9038": "Rehetobel", "9042": "Speicher", "9043": "Trogen",
  "9044": "Wald AR", "9050": "Appenzell", "9052": "Niederteufen",
  "9053": "Teufen AR", "9054": "Haslen AI", "9055": "Bühler",
  "9056": "Gais", "9057": "Weissbad", "9058": "Brülisau",
  "9062": "Lustmühle", "9063": "Stein AR", "9064": "Hundwil",
  "9100": "Herisau", "9102": "Herisau", "9103": "Schwellbrunn",
  "9104": "Waldstatt", "9105": "Schönengrund", "9107": "Urnäsch",
  "9108": "Gonten", "9112": "Schachen b. Herisau"
};

export default NPA_LOCALITES;
